module.exports = {"id":"dp3_3l1q1","text":"Copyright and licences","instructions":"When you create original digital content, what usually applies automatically?","groupTitle":"Digital Profiler Knowledge Matrix","multiselect":false,"category":"3.3","questionType":"PickOne","random":true,"options":[{"id":"dp3_3l1q1-a1","text":"Copyright protection applies","score":1.8},{"id":"dp3_3l1q1-a2","text":"Licence must be requested","score":0},{"id":"dp3_3l1q1-a3","text":"Public use is allowed","score":0}]}


//////////////////
// WEBPACK FOOTER
// ./src/constants/dp/questions/cat3.3/l1q1.json
// module id = 1155
// module chunks = 41